import React from 'react'
import { IClinique } from 'components/core/types'
import CliniquesSliderNavArrow from 'components/ui/CliniquesSliderNavArrow'
import CliniquesSliderNavDot from 'components/ui/CliniquesSliderNavDot'
import Container from 'components/ui/Container'
import { css, StyleSheet } from 'aphrodite'
import useResponsive from 'hooks/useResponsive'

interface CliniquesSliderNavProps {
  activeSlide: number,
  cliniques: IClinique[],
  paddingLeft?: number,
  goto: (i: number) => void,
  next: () => void,
  prev: () => void,
}
const CliniquesSliderNav = ({
  activeSlide,
  cliniques,
  paddingLeft,
  goto,
  next,
  prev,
}: CliniquesSliderNavProps) => {
  const { compareTag } = useResponsive()
  const styles = StyleSheet.create({
    container: {
      paddingRight: paddingLeft,
    },
    dots: {
      position: 'initial',
      display: 'flex',
    },
  })

  return (
    <div className={css(styles.container)}>
      <Container>
        <div className="slick-slider-dot-nav tw-col-span-12 tw-py-7">
          <div className="tw-flex tw-justify-center tw-w-full">
            {cliniques.length > 1 && (<CliniquesSliderNavArrow alt="précédent" action={prev} />)}
            {compareTag('md') && (
              <div className="dots tw-flex tw-items-center">
                <ul className={`tw-flex tw-flex-wrap tw-items-center ${css(styles.dots)}`} role="tablist">
                  {cliniques.map((clinique, index) => (
                    <CliniquesSliderNavDot
                      index={index}
                      isActive={activeSlide === index}
                      goTo={goto}
                      key={clinique.id}
                    />
                  ))}
                </ul>
              </div>
            )}
            {cliniques.length > 1 && (<CliniquesSliderNavArrow alt="suivant" action={next} left={false} />)}
          </div>
        </div>
      </Container>
    </div>
  )
}
CliniquesSliderNav.defaultProps = {
  paddingLeft: 0,
}
export default CliniquesSliderNav
